import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { isMobileState } from '../../recoil/selectors';
import { VNeckBraLanderMobile } from './VNeckBraLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { ProductComparison } from '../components/ProductComparison';
import { LanderTopHero } from '../components/LanderTopHero';
import { allProductsState } from '../../recoil/atoms';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { useLanderControls } from '../LanderContext';
import { useProductAssets } from '../../hooks/useProductAssets';

export const VNeckBraLander: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const isMobile = useRecoilValue(isMobileState);
  const { scrollToProductSection } = useLanderControls();

  const product = allProducts[ProductHandle.VNeckBra];
  const productAssets = useProductAssets(product);
  const wistiaVideoId = productAssets.videos[0]?.wistiaId;
  const padding = { padding: '56.25% 0 0 0' };

  if (isMobile) {
    return <VNeckBraLanderMobile />;
  }

  return (
    <>
      <CardBody>
        <LanderTopHero
          maxHeroContainerHeight={'1061px'}
          heroImage={'desktop-v-neck-bra-lander-top-hero.jpg'}
          title={'V-Neck Bra'}
          subTitle={'So comfortable you’ll forget you’re wearing a bra.'}
        >
          <HeroCallout
            orderIndex={0}
            label="Comfortable straps"
            inlineStyles={{
              desktop: {
                right: `5%`,
                top: `28%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={'Soft removable cups'}
            inlineStyles={{
              desktop: {
                right: `9%`,
                top: `40%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label="Wire-free lift"
            inlineStyles={{
              desktop: {
                right: `22%`,
                top: `46%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-vneck-bra-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'Bonding at the cradle lifts your chest for a supportive, comfortable lift.',
            },
            {
              imgName: 'feature-vneck-bra-desktop-2.jpg',
              title: 'Invisible seams ',
              description: 'Bonded seams lay flat against skin and disappear completely under clothes.',
            },
            {
              imgName: 'feature-vneck-bra-desktop-3.jpg',
              title: 'Totally smooth',
              description: 'Compressive stretch fabric and a flattering cut prevent bumps and bulges.',
            },
          ]}
        />
        <ProductComparison
          onCtaClick={scrollToProductSection}
          competitorImage="vneck-bra-competitor.jpg"
          honeyloveImage="vneck-bra-honeylove.jpg"
          honeyloveText="VNeck Bra"
          competitorText="Competitor"
          title={
            <>
              A smoother finish <br /> under fitted tops.
            </>
          }
        />
        {wistiaVideoId && (
          <div style={{ padding: '50px 60px', paddingTop: 40, boxSizing: 'border-box' }}>
            <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
          </div>
        )}
        <ShopAllColors product={allProducts[ProductHandle.VNeckBra]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default VNeckBraLander;
